import localForage from 'localforage';

import { AsyncStorage } from 'types';

import logger from '../logger';

const asyncStorage: AsyncStorage = (() => {
  const getItem = async (key: string) => {
    try {
      const item = await localForage.getItem(key);
      return item?.toString();
    } catch (error) {
      logger.warn(`Error decoding asyncStorage item at key '${key}'`, error);
      return undefined;
    }
  };

  const setItem = async (key: string, item: string) => {
    try {
      await localForage.setItem(key, item);
      return true;
    } catch (error) {
      logger.warn(`Error setting asyncStorage item '${key}'`, error);
      return false;
    }
  };
  const removeItem = async (key: string) => {
    try {
      await localForage.removeItem(key);
      return true;
    } catch (error) {
      logger.warn(`Error remove asyncStorage item '${key}'`, error);
      return false;
    }
  };

  const iterate = async (iteratorF: (value: string, key: string, idx: number) => void) => {
    try {
      await localForage.iterate(iteratorF);
      return true;
    } catch (error) {
      logger.warn('Error iterate asyncStorage', error);
      return false;
    }
  };

  const getKeys = async () => localForage.keys();

  const clear = async () => {
    try {
      await localForage.clear();
      return true;
    } catch (error) {
      logger.warn('Error clear asyncStorage', error);
      return false;
    }
  };

  return {
    clear,
    getItem,
    getKeys,
    iterate,
    setItem,
    removeItem,
  };
})();

export default asyncStorage;
